<template>
  <div>
    <div class="inputPanel">
      <div class="inputPanel__col inputPanel__question">
        <label style="font-weight: 500;">
          Please confirm number of items per class and format for accurate additional savings calculation.
        </label>
      </div>
    </div>
    <div class="frankinForm__letters" :class="{'inputPanel__error' : class1_letters_validation}">
      <div class="imagePanel">
        <img src="../../../../../../static/styles/mailkit/img/stamp.jpg" alt=""/>
      </div>
      <div class="inputPanel inputPanel--tight">
        <div class="inputPanel__col inputPanel__question inputPanel__question--bordered">
          <label>1st Class Standard Letters i.e. DL or C5 </label>
        </div>
        <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull">
          <input @keyup="checkValidation()" type="number" class="inputReg" name="1stclassstandard" id="1stclassstandard" placeholder="Enter Value" v-model="class1_standard_letters" v-positive-numbers-only/>
        </div>
      </div>
      <div class="inputPanel inputPanel--tight">
        <div class="inputPanel__col inputPanel__question inputPanel__question--bordered">
          <label>1st Class Large Letters up to 100g </label>
        </div>
        <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull">
          <input @keyup="checkValidation()" type="number" class="inputReg" name="100g1st" id="100g1st" placeholder="Enter Value" v-model="class1_large_100_letters" v-positive-numbers-only/>
        </div>
      </div>
      <div class="inputPanel inputPanel--tight">
        <div class="inputPanel__col inputPanel__question inputPanel__question--bordered">
          <label>1st Class Large Letters up to 100g - 250g </label>
        </div>
        <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull">
          <input @keyup="checkValidation()" type="number" class="inputReg" name="100250g1st" id="100250g1st" placeholder="Enter Value" v-model="class1_large_100_250_letters" v-positive-numbers-only/>
        </div>
      </div>
      <div class="inputPanel inputPanel--tight">
        <div class="inputPanel__col inputPanel__question inputPanel__question--bordered">
          <label>1st Class Large Letters between 250g - 500g </label>
        </div>
        <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull">
          <input @keyup="checkValidation()" type="number" class="inputReg" name="250500g1st" id="250500g1st" placeholder="Enter Value" v-model="class1_large_250_500_letters" v-positive-numbers-only/>
        </div>
      </div>
      <div class="inputPanel inputPanel--tight">
        <div class="inputPanel__col inputPanel__question inputPanel__question--bordered">
          <label>1st Class Large Letters between 500g - 750g</label>
        </div>
        <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull">
          <input @keyup="checkValidation()" type="number" class="inputReg" name="500700g1st" id="500700g1st" placeholder="Enter Value" v-model="class1_large_500_750_letters" v-positive-numbers-only/>
        </div>
      </div>

      <error-modal>
        Please see our guide HERE on how to pull this breadkdown from the Pitney Bowes or Quadient (Neopost) web portal.
        <br>
        Frama does not offer this level of detail.
        <br>
        FP does not offer this level of detail unless you are using Navigator plus on your FP machine.
        <br>
        If you do not have this detail and would like to proceed with your quote based on you estimated typical volumes please proceed, or you can utilise our infromation gathering service. This service allows us on your consent to gather all necessary information and detail on your behalf. <a
        href="https://themailingexpert.com/let-us-do-it-for-you/" target="_blank">Click here</a> to understand more and to request this free service.**
      </error-modal>
    </div>


    <div class="frankinForm__letters" :class="{'inputPanel__error' : class2_letters_validation}">
      <div class="imagePanel">
        <img src="../../../../../../static/styles/mailkit/img/stamp2.jpg" alt=""/>
      </div>
      <div class="inputPanel inputPanel--tight">
        <div class="inputPanel__col inputPanel__question inputPanel__question--bordered">
          <label>2nd Class Standard Letters i.e. DL or C5 </label>
        </div>
        <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull">
          <input @keyup="checkValidation()" type="number" class="inputReg" name="dlorc5" id="dlorc5" placeholder="Enter Value" v-model="class2_standard_letters" v-positive-numbers-only/>
        </div>
      </div>
      <div class="inputPanel inputPanel--tight">
        <div class="inputPanel__col inputPanel__question inputPanel__question--bordered">
          <label>2nd Class Large Letters up to 100g </label>
        </div>
        <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull">
          <input @keyup="checkValidation()" type="number" class="inputReg" name="100g2nd" id="100g2nd" placeholder="Enter Value" v-model="class2_large_100_letters" v-positive-numbers-only/>
        </div>
      </div>
      <div class="inputPanel inputPanel--tight">
        <div class="inputPanel__col inputPanel__question inputPanel__question--bordered">
          <label>2nd Class Large Letters up to 100g - 250g </label>
        </div>
        <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull">
          <input @keyup="checkValidation()" type="number" class="inputReg" name="100250g" id="100250g" placeholder="Enter Value" v-model="class2_large_100_250_letters" v-positive-numbers-only/>
        </div>
      </div>
      <div class="inputPanel inputPanel--tight">
        <div class="inputPanel__col inputPanel__question inputPanel__question--bordered">
          <label>2nd Class Large Letters between 250g - 500g </label>
        </div>
        <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull">
          <input @keyup="checkValidation()" type="number" class="inputReg" name="250500g" id="250500g" placeholder="Enter Value" v-model="class2_large_250_500_letters" v-positive-numbers-only/>
        </div>
      </div>
      <div class="inputPanel inputPanel--tight">
        <div class="inputPanel__col inputPanel__question inputPanel__question--bordered">
          <label>2nd Class Large Letters between 500g - 750g </label>
        </div>
        <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull">
          <input @keyup="checkValidation()" type="number" class="inputReg" name="500700g" id="500700g" placeholder="Enter Value" v-model="class2_large_500_750_letters" v-positive-numbers-only/>
        </div>
      </div>

      <error-modal>
        Please see our guide HERE on how to pull this breadkdown from the Pitney Bowes or Quadient (Neopost) web portal.
        <br>
        Frama does not offer this level of detail.
        <br>
        FP does not offer this level of detail unless you are using Navigator plus on your FP machine.
        <br>
        If you do not have this detail and would like to proceed with your quote based on you estimated typical volumes please proceed, or you can utilise our infromation gathering service. This service allows us on your consent to gather all necessary information and detail on your behalf. <a
        href="https://themailingexpert.com/let-us-do-it-for-you/" target="_blank">Click here</a> to understand more and to request this free service.**
      </error-modal>
    </div>

  </div>
</template>
<script>
  import {mapState, mapMutations, mapActions} from 'vuex'
  import InfoModal from '../../InfoModal.vue'
  import ErrorModal from '../../ErrorModal.vue'

  export default {
    components: {
      'info-modal': InfoModal,
      'error-modal': ErrorModal
    },
    data() {
      return {
        class1_letters_validation: false,
        class2_letters_validation: false,
      }
    },
    computed: {
      ...mapState('QuoteForm', ['step2', 'invalidFields']),
      class1_standard_letters: {
        get() {
          return this.step2.class1_standard_letters
        },
        set(value) {
          this.updateStep2({class1_standard_letters: value})
        }
      },
      class1_large_100_letters: {
        get() {
          return this.step2.class1_large_100_letters
        },
        set(value) {
          this.updateStep2({class1_large_100_letters: value})
        }
      },
      class1_large_100_250_letters: {
        get() {
          return this.step2.class1_large_100_250_letters
        },
        set(value) {
          this.updateStep2({class1_large_100_250_letters: value})
        }
      },
      class1_large_250_500_letters: {
        get() {
          return this.step2.class1_large_250_500_letters
        },
        set(value) {
          this.updateStep2({class1_large_250_500_letters: value})
        }
      },
      class1_large_500_750_letters: {
        get() {
          return this.step2.class1_large_500_750_letters
        },
        set(value) {
          this.updateStep2({class1_large_500_750_letters: value})
        }
      },
      class2_standard_letters: {
        get() {
          return this.step2.class2_standard_letters
        },
        set(value) {
          this.updateStep2({class2_standard_letters: value})
        }
      },
      class2_large_100_letters: {
        get() {
          return this.step2.class2_large_100_letters
        },
        set(value) {
          this.updateStep2({class2_large_100_letters: value})
        }
      },
      class2_large_100_250_letters: {
        get() {
          return this.step2.class2_large_100_250_letters
        },
        set(value) {
          this.updateStep2({class2_large_100_250_letters: value})
        }
      },
      class2_large_250_500_letters: {
        get() {
          return this.step2.class2_large_250_500_letters
        },
        set(value) {
          this.updateStep2({class2_large_250_500_letters: value})
        }
      },
      class2_large_500_750_letters: {
        get() {
          return this.step2.class2_large_500_750_letters
        },
        set(value) {
          this.updateStep2({class2_large_500_750_letters: value})
        }
      },
    },
    watch: {
      invalidFields: function () {
        this.checkValidation()
      }
    },
    methods: {
      ...mapMutations('QuoteForm', ['updateStep2']),
      checkValidation() {
        this.class1_letters_validation = !(
          !this.invalidFields.class1_standard_letters
          && !this.invalidFields.class1_large_100_letters
          && !this.invalidFields.class1_large_100_250_letters
          && !this.invalidFields.class1_large_250_500_letters
          && !this.invalidFields.class1_large_500_750_letters
          && !this.invalidFields.class2_standard_letters
          && !this.invalidFields.class2_large_100_letters
          && !this.invalidFields.class2_large_100_250_letters
          && !this.invalidFields.class2_large_250_500_letters
          && !this.invalidFields.class2_large_500_750_letters
        )
        this.class2_letters_validation = !(
          !this.invalidFields.class1_standard_letters
          && !this.invalidFields.class1_large_100_letters
          && !this.invalidFields.class1_large_100_250_letters
          && !this.invalidFields.class1_large_250_500_letters
          && !this.invalidFields.class1_large_500_750_letters
          && !this.invalidFields.class2_standard_letters
          && !this.invalidFields.class2_large_100_letters
          && !this.invalidFields.class2_large_100_250_letters
          && !this.invalidFields.class2_large_250_500_letters
          && !this.invalidFields.class2_large_500_750_letters)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Quotes/Form/Step-2/Conditionals/Form_FrankingFormLetters.vue